import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'm3.5 11.657-1.01 1.11a2.62 2.62 0 0 1-.85-1.93V4.5a2.623 2.623 0 0 1 2.62-2.62h3.16a.749.749 0 0 1 .53.22l1.31 1.3h1.45v1.5H8.946a.749.749 0 0 1-.53-.22l-1.31-1.3h-2.85a1.125 1.125 0 0 0-1.12 1.12v6.34a1.113 1.113 0 0 0 .364.817ZM15.256 3.6l-.97.97a2.578 2.578 0 0 1 .44 1.45v4.82a2.616 2.616 0 0 1-2.62 2.62h-6.72l-1.28 1.28a.742.742 0 0 1-.53.22.725.725 0 0 1-.53-.22.754.754 0 0 1 0-1.06L14.2 2.527a.754.754 0 0 1 1.06 0 .767.767 0 0 1-.004 1.073Zm-2.03 2.42a1.332 1.332 0 0 0-.05-.34l-6.29 6.28h5.22a1.118 1.118 0 0 0 1.12-1.12Z';
const draw24px = 'M16.68,5.87l-1.4,1.5H13.16a.75.75,0,0,1-.53-.22l-2.11-2.1H6a2.11,2.11,0,0,0-2.11,2.1v9.7a2.11,2.11,0,0,0,.69,1.55L3.49,19.45a3.47,3.47,0,0,1-1.11-2.6V7.15A3.61,3.61,0,0,1,6,3.55h4.84a.71.71,0,0,1,.53.22l2.11,2.1Zm5.85-.38L20.8,7.21a3.52,3.52,0,0,1,.81,2.27v7.37A3.61,3.61,0,0,1,18,20.45H7.56L5.48,22.53a.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06l17-17a.75.75,0,0,1,1.06,0A.77.77,0,0,1,22.53,5.49Zm-2.42,4a2,2,0,0,0-.38-1.19L9.06,19H18a2.11,2.11,0,0,0,2.11-2.1Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const FolderSlashIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'folderSlash'));
FolderSlashIcon.displayName = 'FolderSlashIcon';
FolderSlashIcon.propTypes = Icon.propTypes;
FolderSlashIcon.renderIcon = props => /*#__PURE__*/React.createElement(FolderSlashIcon, props);
export default FolderSlashIcon;
//# sourceMappingURL=FolderSlashIcon.js.map